import { useDomain } from '@useDomain';

import DefaultOurTeam from "../organizationCustomWebsite/default/DefaultOurTeam";
import FabOurTeam from "../organizationCustomWebsite/fab/FabOurTeam";

function DynamicOrgOurTeam() {
 const { slug, domain, organization } = useDomain();

 console.log("🔎 DynamicOrgOurTeam:", { slug, domain, organization }); // ✅ (you should still see everything here)

 if (!organization) {
  return null;  // ✅ better than returning null
 }


 if (slug === "fastactionbasketball" || domain === "fastactionbasketball.com") {
  console.log('✅ Loading FabOurTeam');
  return <FabOurTeam />;
 }


 return <DefaultOurTeam />;
}

export default DynamicOrgOurTeam;
